import { render, staticRenderFns } from "./Join-us.vue?vue&type=template&id=211950aa&scoped=true"
import script from "./Join-us.vue?vue&type=script&lang=js"
export * from "./Join-us.vue?vue&type=script&lang=js"
import style0 from "./Join-us.vue?vue&type=style&index=0&id=211950aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211950aa",
  null
  
)

export default component.exports